import { OuterContentContainer } from "@shared/ui/OuterContentContainer";
import { Loader } from "@shared/ui/Loader";
import { Program as ProgramType } from "@platform/types/dashboard.types";
import {
  User as UserType,
  Organization as OrganizationType,
} from "@platform/types/platform.types";
import { AppPageHeader } from "@shared/ui/AppPageHeader";
import UpdatePasswordForm from "@shared/features/auth/components/UpdatePasswordForm/UpdatePasswordForm";
import SettingsProfileForm from "../SettingsProfile/SettingsProfileForm";
import SettingsAccountForm from "../SettingsAccount/SettingsAccountForm";
import SettingsPlanDetailsContainer from "../SettingsPlanDetails/SettingsPlanDetailsContainer";
import { SettingsSection } from "../SettingsSection/SettingsSection";
import { normalizeUserData } from "../../utils/normalizeUserData";

export type Props = {
  program: ProgramType;
  user: UserType;
  organization: OrganizationType;
};

export function Settings({ program, user }: Props) {
  return (
    <OuterContentContainer className="flex flex-1" innerClassName="gap-8">
      <>
        <div className="flex flex-col gap-8 py-4">
          <AppPageHeader
            title="Settings"
            description="Edit your profile and update your password."
          />
        </div>
        <div className="w-full flex flex-col gap-6 pb-8 max-w-3xl">
          {!program || !user ? (
            <Loader isFullPage />
          ) : (
            <>
              <SettingsSection title="Your Profile">
                <SettingsProfileForm user={normalizeUserData(user)} />
              </SettingsSection>
              <SettingsSection title="Your Account">
                <SettingsAccountForm user={normalizeUserData(user)} />
              </SettingsSection>
              <SettingsSection title="Change Password">
                <UpdatePasswordForm user={normalizeUserData(user)} />
              </SettingsSection>
              <SettingsSection
                title="Your plan"
                description="Individual participation in the pilot session is enabled by Sending Institutions."
              >
                <SettingsPlanDetailsContainer />
              </SettingsSection>
            </>
          )}
        </div>
      </>
    </OuterContentContainer>
  );
}

export default Settings;
